import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-closed-branch-dialog',
  templateUrl: './closed-branch-dialog.component.html',
  styleUrls: ['./closed-branch-dialog.component.scss']
})
export class ClosedBranchDialogComponent {
  content: string="";
  constructor(
    public dialogRef: MatDialogRef<ClosedBranchDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  
  ){
   this.content=data.content;
  }
  closeDialog() {
    this.dialogRef.close({ event: 'Cancel' });
  }
}
